// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1sItY","title":"AfterBackImages_title__LH4uh","images":"AfterBackImages_images__1Ak0U"};